import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
const InboxDashboard = lazy(() => import('../containers/Inbox/InboxDashboard'));
function ChatRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: `${url}/channel/:channelId` },
            React.createElement(InboxDashboard, null)),
        React.createElement(Route, { path: `${url}/private/:conversationId` },
            React.createElement(InboxDashboard, null)),
        React.createElement(Route, { path: url },
            React.createElement(InboxDashboard, null))));
}
export default ChatRouts;
